/*
 * Represents the models that compose the total returns chart component.
 */

import {
  AnnualizedPeriodsPerformance,
  CurrentYearPeriodsPerformance,
} from '../total-returns/total-returns.model';

export enum TotalReturnsChartDataType {
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
}

export enum TotalReturnsChartType {
  AnnualizedPerformance = 'AnnualizedPerformance',
  CurrentYearPerformance = 'CurrentYearPerformance',
}

type CurrentYearPerformanceValues = {
  monthEnd: CurrentYearPeriodsPerformance;
};

type AnnualizedPerformanceValues = {
  monthEnd: AnnualizedPeriodsPerformance;
  quarterEnd: AnnualizedPeriodsPerformance;
};

export type TotalReturnsChart = {
  dataValueType: TotalReturnsChartDataType;
  chartType: TotalReturnsChartType;
  currentYearPerformanceValues: CurrentYearPerformanceValues | null;
  annualizedPerformanceValues: AnnualizedPerformanceValues | null;
  portfolioInceptionDate: string;
  assetClass: string;
};

export type TotalReturnsChartArgs = {
  componentObject: TotalReturnsChart;
};
